let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Rjqr")).then(() => parcelRequire('agOcn'));